const Loader = () => {
  return (
    <div className='Loader'>
      <span className="Loading"></span> Loading
    </div>
  )
}

export default Loader;